import { useEffect } from "react";

const useLockPageScroll = (locked: boolean) => {
  useEffect(() => {
    if (!locked) return undefined;

    const mainElement = document.querySelector("main") as HTMLElement | null;
    const previousBodyOverflow = document.body.style.overflow;
    const previousMainOverflowY = mainElement?.style.overflowY ?? "";

    document.body.style.overflow = "hidden";
    if (mainElement) {
      mainElement.style.overflowY = "hidden";
    }

    return () => {
      document.body.style.overflow = previousBodyOverflow;
      if (mainElement) {
        mainElement.style.overflowY = previousMainOverflowY;
      }
    };
  }, [locked]);
};

export default useLockPageScroll;
